import {
  CategoryType,
  FirestoreDocCategory,
  FirestoreDocCategoryGroup,
} from "breadcommon";

export type RecommendedCategoryGroup = {
  group_name: string;
  categories: {
    name: string;
    type: CategoryType;
    emoji: string;
  }[];
};

export function RecommendedCategoryGroups(): Omit<
  FirestoreDocCategoryGroup,
  "id"
>[] {
  const currentTimestamp = Math.floor(Date.now() / 1000);

  return RECOMMENDED_CATEGORIES.map((group, index) => ({
    name: group.group_name,
    created_timestamp_secs: currentTimestamp,
    order_position: index,
  }));
}

export function RecommendedCategories(
  groupIds: string[],
): Omit<FirestoreDocCategory, "id">[] {
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const categories: Omit<FirestoreDocCategory, "id">[] = [];

  RECOMMENDED_CATEGORIES.forEach((group, groupIndex) => {
    group.categories.forEach((category, categoryIndex) => {
      categories.push({
        name: category.name,
        emoji: category.emoji,
        type: category.type,
        created_timestamp_secs: currentTimestamp,
        order_position: categoryIndex,
        category_group_id: groupIds[groupIndex],
      });
    });
  });

  return categories;
}

export const RECOMMENDED_CATEGORIES: RecommendedCategoryGroup[] = [
  {
    group_name: "Income",
    categories: [
      {
        name: "Salary",
        type: "Income",
        emoji: "💰",
      },
      {
        name: "Misc Income",
        type: "Income",
        emoji: "💵",
      },
    ],
  },
  {
    group_name: "Required Expenses",
    categories: [
      {
        name: "Groceries",
        type: "Expense",
        emoji: "🍏",
      },
      {
        name: "Rent & Utilities",
        type: "Expense",
        emoji: "🏡",
      },
      {
        name: "Car Insurance & Maintenance",
        type: "Expense",
        emoji: "🚗",
      },
      { name: "Healthcare", type: "Expense", emoji: "🚑" },
      { name: "Phone Plan", type: "Expense", emoji: "📶" },
    ],
  },
  {
    group_name: "Discretionary Expenses",
    categories: [
      {
        name: "Fun",
        type: "Expense",
        emoji: "🎉",
      },
      {
        name: "Travel",
        type: "Expense",
        emoji: "✈️",
      },
      {
        name: "Donations",
        type: "Expense",
        emoji: "🫶",
      },
      {
        name: "Other Discretionary Expenses",
        type: "Expense",
        emoji: "🛍️",
      },
    ],
  },
  {
    group_name: "Savings",
    categories: [
      {
        name: "General Savings",
        type: "Savings",
        emoji: "🪺",
      },
    ],
  },
  {
    group_name: "Silent",
    categories: [
      {
        name: "Transfers",
        type: "Silent",
        emoji: "↔️",
      },
    ],
  },
];
